module.exports = {
  language: 'Lingua',
  selectLanguage: 'Seleziona Lingua',
  charging: 'In Carica',
  notCharging: 'Non in Carica',
  advanceSetting: 'Impostazioni Avanzate',
  chargingDesc: 'Inizia la ricarica quando il livello della batteria è inferiore al ',
  enabled: 'Abilitato',
  disabled: 'Disabilitato',
  onPowerRestore: 'Al Ripristino dell\'Alimentazione',
  powerWakeDesc: '** Si prega di utilizzare due caricatori USB indipendenti per caricare rispettivamente il Pi e PiSugar, e mantenere acceso l\'interruttore di alimentazione di PiSugar. Si accenderà automaticamente quando l\'alimentazione esterna viene ripristinata.',
  powerWakeDescFor3: 'PiSugar si accenderà automaticamente quando l\'alimentazione esterna viene ripristinata.',
  powerWakeOffWarning: 'Hai disattivato la funzione di risveglio al ripristino dell\'alimentazione, si prega di non fornire alimentazione esterna separatamente al Raspberry Pi.',
  powerWakeOffTitle: 'Nota',
  confirmButtonText: 'Conferma',
  wakeUpFeature: 'Risveglio Programmato',
  repeat: 'Ripeti',
  repeatEveryday: 'ripeti ogni giorno.',
  repeatOn: 'ripeti il',
  checkAll: 'Seleziona Tutto',
  clearAll: 'Cancella Tutto',
  wakeUpDesc: 'Risveglio programmato alle',
  wakeUpOffDesc: 'Risveglio programmato spento.',
  buttonFunction: 'Funzione Pulsante Personalizzata',
  singleTapLabel: 'Tocco Singolo',
  doubleTapLabel: 'Doppio Tocco',
  longTapLabel: 'Tocco Prolungato',
  singleTap: 'tocco singolo',
  doubleTap: 'doppio tocco',
  longTap: 'tocco prolungato',
  none: 'nessuno',
  edit: 'Modifica',
  customShell: 'Shell Personalizzata',
  shutdown: 'Spegnimento',
  shellModalTitle: {
    single: 'Shell da eseguire per tocco singolo',
    double: 'Shell da eseguire per doppio tocco',
    long: 'Shell da eseguire per tocco prolungato'
  },
  shell: 'Shell',
  shellPlaceholder: 'Inserisci script shell qui...',
  cancel: 'Annulla',
  confirm: 'Conferma',
  triggered: 'Attivato',
  safeShutdown: 'Spegnimento Sicuro',
  batteryLevel: 'Livello Batteria',
  immediately: 'Immediatamente',
  secondsDelay: 'secondi di ritardo',
  rtcTime: 'Ora RTC',
  sysTime: 'Ora Sistema',
  syncTime: 'Sincronizza Ora',
  weekDay: {
    Monday: 'Lunedì',
    Tuesday: 'Martedì',
    Wednesday: 'Mercoledì',
    Thursday: 'Giovedì',
    Friday: 'Venerdì',
    Saturday: 'Sabato',
    Sunday: 'Domenica'
  },
  weekDayShort: {
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mer',
    Thu: 'Gio',
    Fri: 'Ven',
    Sat: 'Sab',
    Sun: 'Dom'
  },
  batteryInputProtect: 'Protezione Ingresso Batteria',
  batteryInputProtectDesc: 'Il processo di ricarica si fermerà quando la batteria raggiunge il 60% ~ 80%, il che può estendere efficacemente la durata della batteria.',
  antiMistouch: 'Anti Tocco Accidentale',
  antiMistouchDesc: 'Quando l\'anti tocco accidentale è attivato, l\'interruttore deve essere cliccato e tenuto premuto per attivarsi.',
  softPoweroff: 'Spegnimento Graduale',
  softPoweroffDesc: 'Utilizzando il pulsante di spegnimento non si spegnerà direttamente l\'alimentazione, il comando di spegnimento sarà inviato dal software.',
  softPoweroffShell: 'Shell Spegnimento Graduale',
  softPoweroffShellDesc: 'Shell da eseguire quando viene attivato l\'evento di spegnimento graduale.',
  changeLoginPassword: 'Cambia Password di Accesso',
  username: 'Nome Utente',
  password: 'Password',
  passwordConfirm: 'Inserisci nuovamente la password',
  usernameCannotBeEmpty: 'Il nome utente non può essere vuoto',
  passwordCannotBeEmpty: 'La password non può essere vuota',
  passwordNotConsistent: 'Le due password inserite devono essere consistenti',
  usernameWithSpace: 'Il nome utente non può contenere spazi',
  passwordWithSpace: 'La password non può contenere spazi',
  changePasswordSuccess: 'La modifica è completata.',
  loginDialog: 'Accesso',
  login: 'Accedi'
}



// WEBPACK FOOTER //
// ./src/locale/it-IT.js